import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES_LIST } from '@/constants/locales';

const rawSavedLanguage = localStorage.getItem('i18n_lang');
const isValidLanguage = SUPPORTED_LANGUAGES_LIST.includes(rawSavedLanguage);
const resolvedLanguage = isValidLanguage ? rawSavedLanguage : DEFAULT_LANGUAGE;

if (!isValidLanguage && rawSavedLanguage) {
    localStorage.setItem('i18n_lang', DEFAULT_LANGUAGE);
}
i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        lng: resolvedLanguage,
        fallbackLng: DEFAULT_LANGUAGE,

        supportedLngs: SUPPORTED_LANGUAGES_LIST,
        defaultNS: 'common',
        ns: [
            'booker',
            'common',
            'customers',
            'feedbacks',
            'integrations',
            'marketing',
            'messaging',
            'misc',
            "notification_center",
            'orders',
            'payments',
            'queries',
            'redux_store',
            'reservations_history',
            'settings',
            'shop',
            'sms',
            'stats',
            'subscription',
            'stripe',
            'answering_machine',
        ],
        // debug: import.meta.env.DEV,
        load: 'all',

        interpolation: {
            escapeValue: false,
        },

        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
    });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js